import $ from "jquery";

export default function() {
  $.ajax("https://ipapi.co/json").then(
    function success(response) {
      if (!sessionStorage.getItem("roaming")) {
        if (response.country === "CA") {
          $(".country-redirect").addClass("visible");
        }
      }
    },

    function fail(data, status) {
      console.log("Request failed:", status);
    }
  );

  $("[data-change-currency]").click(() => {
    $(".shopify-currency-form__select").val("CAD");
    $(".shopify-currency-form__select").trigger("change");
    sessionStorage.setItem("roaming", "true");
  });

  $(".country-redirect__close").click(() => {
    $(".country-redirect").removeClass("visible");
    sessionStorage.setItem("roaming", "true");
  });
}
